import { type ReactNode } from 'react';
import * as st from './stylws.module.scss';

interface ItemInfoProps {
  title: string;
  value?: number | string | ReactNode;
  className?: string;
  description?: string;
}

export const ItemInfo: React.FC<ItemInfoProps> = ({ title, value, className, description }) => (
  <li className={st.item}>
    <span className={st.item__title} title={description ?? ''}>
      {title}
    </span>
    {value && (
      <div className={`${value ? st.item__value : st.item__empty} ${className || ''}`}>{value}</div>
    )}
  </li>
);
